module.exports = __webpack_public_path__ + "img/photo.64b01e08.jpg";